(function() {
    const latestElements = document.querySelectorAll('.latest');

    latestElements.forEach(function(latestElement) {
        function initializeSwiper() {
            const $class = 'latest';
            const swiper = new Swiper(latestElement.querySelector(`.${$class}__carousel`), {
                wrapperClass: `${$class}__ribbon`,
                slideClass: `${$class}__panel`,
                direction: 'horizontal',
                loop: false,
                speed: 600,
                navigation: {
                    prevEl: latestElement.querySelector(`.${$class}__controller--left`),
                    nextEl: latestElement.querySelector(`.${$class}__controller--right`),
                    disabledClass: `conind__controller--disabled-black`,
                },
                allowTouchMove: true,
                breakpoints: {
                    1: {
                        slidesPerView: 1.07,
                        spaceBetween: 16,
                    },
                    450: {
                        slidesPerView: 1.25,
                        spaceBetween: 16,
                    },
                    550: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    700: {
                        slidesPerView: 1.75,
                        spaceBetween: 16,
                    },
                    850: {
                        slidesPerView: 2.07,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 2.4851,
                        spaceBetween: 16,
                    },
                },
            });
    
            // Dodanie klasy 'latest__carousel--loaded' po inicjalizacji Swipera
            const carouselElement = latestElement.querySelector(`.${$class}__carousel`);
            if (carouselElement) {
                carouselElement.classList.add(`${$class}__carousel--loaded`);
            }
    
            const conindBlock = latestElement.querySelector(`.${$class}__block`);
    
            function updateSlideCount() {
                // Use the current window width to decide the slide count
                const windowWidth = window.innerWidth;
                let slideCount;
    
                if (windowWidth < 700) {
                    slideCount = swiper.slides.length;
                } else {
                    slideCount = swiper.slides.length - 1;
                }
    
                const blockWidthPercentage = 100 / slideCount;
    
                // Set initial size and position
                conindBlock.style.width = `${blockWidthPercentage}%`;
                updateBlockPosition();
    
                // Update position on slide change
                swiper.on('slideChange', updateBlockPosition);
    
                function updateBlockPosition() {
                    const activeIndex = swiper.realIndex;
                    conindBlock.style.left = `${blockWidthPercentage * activeIndex}%`;
                }
            }
    
            // Initialize or update slide count on load and resize
            updateSlideCount();
            window.addEventListener('resize', updateSlideCount);

        }
        
        // Initialize Swiper for each instance of '.latest' on page load
        window.addEventListener('load', initializeSwiper);
    });
})();